import { jsx } from "react/jsx-runtime";
import * as PLACEHOLDERS from "../../placeholders";
import { EPlaceholderIconsNames } from "../../placeholders";
import pascalCase from "../../shared/utils/pascal-case";
import { useTheme } from "../ThemeProvider";
const ICON_SX = {
  width: "96px",
  height: "96px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
const PlaceholderIcon = (props) => {
  const { name, defaultMode, className } = props;
  const currentTheme = useTheme();
  const mode = defaultMode || currentTheme.palette.mode;
  const iconName = pascalCase(`${EPlaceholderIconsNames[name] ?? name}-${mode}`);
  const PlaceholderIcon2 = PLACEHOLDERS[iconName] ?? void 0;
  if (!PlaceholderIcon2)
    throw new Error(`Unsupported placeholder name: ${name} for mode ${mode}`);
  return /* @__PURE__ */ jsx(PlaceholderIcon2, { sx: ICON_SX, className });
};
var PlaceholderIcon_default = PlaceholderIcon;
export {
  EPlaceholderIconsNames,
  PlaceholderIcon_default as default
};
